import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelFont(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--panelFont', getDefaultPanelColors().panelFont);
}
